import { createContext } from 'react';

export const LayoutContext = createContext({});

export const LayoutProvider = (props) => {
  const {
    children,
    resourceData,
    websiteSectionList,
    catalogList,
    isMro,
    onlySScreen = false, // 只兼容小屏幕
    globalSearchKeyword,
    showMemberWebsite, // 部分非首页也需要显示成员网站
    showSeoCatalog = false, // 是否显示SEO的分类
  } = props;

  return (
    <LayoutContext.Provider
      value={{
        resourceData,
        websiteSectionList,
        catalogList,
        isMro,
        onlySScreen,
        globalSearchKeyword,
        showMemberWebsite,
        showSeoCatalog,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};
